import { ChangeEvent, ComponentProps, Fragment, KeyboardEvent, useId } from "react";
import { ExclamationCircleIcon } from "@heroicons/react/20/solid";

export interface InputProps extends Omit<ComponentProps<"input">, "onChange"> {
  onChange?: (event: string) => void;
  validationMessage?: string;
  icon?: any;
  onSubmit?: () => void;
}

export function Input(props: InputProps) {
  const {
    id,
    className,
    onChange,
    onSubmit,
    icon,
    validationMessage,
    type = "text",
    disabled = false,
    ...rest
  } = props;
  const generatedId = useId();

  async function handleKeyDown(event: KeyboardEvent<HTMLInputElement>) {
    if (event.key !== "Enter" || !onSubmit) return;
    onSubmit();
  }

  function handleOnChange(e: ChangeEvent<HTMLInputElement>) {
    if (!onChange) return;
    onChange(e.target.value);
  }

  return (
    <Fragment>
      <div className="mt-1 relative rounded-md shadow-sm">
        {icon && (
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            {icon}
          </div>
        )}
        <input
          {...rest}
          className={`
                        border border-neutral-500
                        rounded
                        shadow
                        ${validationMessage ? "border-error-300 text-error-900 placeholder-error-300 focus:outline-none focus:ring-error-500 focus:border-error-500 " : ""}
                        ${icon ? "pl-9" : ""}
                        py-2 px-3 my-2 ${className ?? ""}`}
          id={id ?? generatedId}
          type={type}
          disabled={disabled}
          onKeyDown={handleKeyDown}
          onChange={handleOnChange}
        />
        {validationMessage && (
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
            <ExclamationCircleIcon className="h-5 w-5 text-error-500" aria-hidden="true" />
          </div>
        )}
      </div>
      {validationMessage && (
        <p className="mt-1 mb-4 text-sm text-error-600" id={`${id ?? generatedId}-error`}>
          {validationMessage}
        </p>
      )}
    </Fragment>
  );
}
